import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import axiosInstance from "../../axios/axios";
import { dateFormatter, checkRegisteredUser } from "../../utils/helper";
import Loading from "../../Components/Loading";
import { toast } from "react-toastify";
import { queryClient } from "../../routes/Reactquery";
import { fetchProfile } from "../../fetch/profile/myProfile";
import "./VacancyIndividual.css";

const VacancyIndividual = () => {
  const navigate = useNavigate();
  const { vacancyId } = useParams();

  console.log(vacancyId);
  const [isLoading, setIsLoading] = useState(true);
  const [vacancy, setVacancy] = useState(null);
  const [isApply, setIsApply] = useState(false);
  const isLoggedIn = checkRegisteredUser();

  const {
    isLoading: isProfileLoading,
    error: profileError,
    data: profileData,
  } = fetchProfile();

  const fetchData = async () => {
    try {
      setIsLoading(true);
      const response = await axiosInstance.get(
        `/unauth/vacancy/mobile/${vacancyId}`
      );
      console.log("response", response);
      if (response.data && response.data.data && response.data.data.data) {
        setVacancy(response.data.data.data);
      }
    } catch (error) {
      console.error("Error fetching vacancy:", error);
      setVacancy(null);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    fetchData();
  }, [vacancyId]);

  if (isLoading) {
    return (
      <div className="vacancy-individual-loading">
        <Loading />
      </div>
    );
  }

  if (!vacancy) {
    return (
      <div className="vacancy-individual-container">
        <div className="vacancy-individual-error">
          <h3>Vacancy not found</h3>
          <button onClick={() => navigate(-1)} className="btn-primary">Go Back</button>
        </div>
      </div>
    );
  }

  const isExpired = vacancy.expiryDate && new Date(vacancy.expiryDate) < new Date();

  const handleApply = () => {
    if (profileData?.data?.user?.id == vacancy?.user?._id || profileData?.data?.user?.id == vacancy?.user) {
      toast.warn("You cannot apply for your own vacancy");
      return;
    }
    if (isLoggedIn) {
      setIsApply(true);
      axiosInstance
        .put(`/vacancy/apply`, { vacancyId: vacancyId })
        .then(async (res) => {
          setIsApply(false);
          toast.success("Applied to Vacancy");
          await queryClient.invalidateQueries(["profile"]);
          await queryClient.invalidateQueries(["vacancies"]);
          setTimeout(() => {
            navigate("/vacancies-applied");
          }, 1000);
        })
        .catch((err) => {
          setIsApply(false);
          toast.error("Applying failed");
        });
    } else {
      navigate("/login");
    }
  };

  const handleDownloadFile = () => {
    if (!isLoggedIn) {
      toast.warn("Please login to download the file");
      navigate("/login");
      return;
    }
    if (vacancy?.file) {
      window.open(`/${vacancy.file}`, "_blank");
    }
  };

  return (
    <div className="vacancy-individual-container">
      {/* Header Section */}
      <div className="vacancy-header">
        <button
          onClick={() => navigate(-1)}
          className="back-button"
        >
          ← Go Back
        </button>
        <div className="vacancy-status-badges">
          {vacancy?.isTrainer && <span className="status-tag status-tag-orange">Trainer</span>}
          {vacancy?.isConsultant && <span className="status-tag status-tag-gold">Consultant</span>}
          {isExpired && <span className="status-tag status-tag-error">Expired</span>}
          {vacancy?.isFeatured && <span className="status-tag status-tag-featured">Featured</span>}
        </div>
      </div>

      {/* Main Title Section */}
      <div className="vacancy-title-card">
        <h2 className="vacancy-title">
          {vacancy.title}
        </h2>
        <div className="vacancy-meta">
          <div className="meta-item">
            <span className="meta-icon">📅</span>
            <span className="meta-label">Posted:</span>
            <span>{dateFormatter(vacancy.postedDate)}</span>
          </div>
          <div className="meta-item">
            <span className="meta-icon">⏰</span>
            <span className="meta-label">Expires:</span>
            <span className={isExpired ? "expired-text" : ""}>
              {dateFormatter(vacancy.expiryDate)}
            </span>
          </div>
          {vacancy.appliedBy && (
            <div className="meta-item">
              <span className="meta-icon">👤</span>
              <span className="meta-label">Applications:</span>
              <strong>{vacancy.appliedBy.length}</strong>
            </div>
          )}
        </div>
        {/* Apply Button */}
        <div className="vacancy-apply-section">
          <button
            className={`apply-button ${
              profileData?.data?.user?.id == vacancy?.user?._id ||
              profileData?.data?.user?.id == vacancy?.user
                ? "apply-button-disabled"
                : ""
            }`}
            onClick={handleApply}
            disabled={
              isApply ||
              profileData?.data?.user?.id == vacancy?.user?._id ||
              profileData?.data?.user?.id == vacancy?.user
            }
          >
            {isApply ? <Loading /> : "Apply for this Vacancy"}
          </button>
        </div>
      </div>

      <div className="vacancy-content-grid">
        {/* Left Column */}
        <div className="vacancy-left-column">
          {/* Requirements Section */}
          <div className="vacancy-section-card">
            <div className="vacancy-card-header">
              <h3>Requirements</h3>
            </div>
            <div className="vacancy-card-body">
              <p className="vacancy-requirements">
                {vacancy.requirements}
              </p>
            </div>
          </div>

          {/* Required Skills Section */}
          {vacancy.requiredSkills && vacancy.requiredSkills.length > 0 && (
            <div className="vacancy-section-card">
              <div className="vacancy-card-header">
                <h3>Required Skills</h3>
              </div>
              <div className="vacancy-card-body">
                <div className="skills-container">
                  {vacancy.requiredSkills.map((skill, index) => (
                    <span key={index} className="skill-tag">
                      {skill}
                    </span>
                  ))}
                </div>
              </div>
            </div>
          )}

          {/* Candidate Requirements Section */}
          <div className="vacancy-section-card">
            <div className="vacancy-card-header">
              <h3>Candidate Requirements</h3>
            </div>
            <div className="vacancy-card-body">
              <div className="info-grid">
                <div className="info-item">
                  <strong>Minimum Experience:</strong>
                  <span>{vacancy.candidate?.minExperience || "Not specified"}</span>
                </div>
                <div className="info-item">
                  <strong>First Language:</strong>
                  <span>{vacancy.candidate?.firstLanguage || "Not specified"}</span>
                </div>
                <div className="info-item">
                  <strong>Second Language:</strong>
                  <span>{vacancy.candidate?.secondLanguage || "Not specified"}</span>
                </div>
                <div className="info-item">
                  <strong>Nationality:</strong>
                  <span>{vacancy.candidate?.nationality || "Not specified"}</span>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Right Column */}
        <div className="vacancy-right-column">
          {/* Location Section */}
          <div className="vacancy-section-card">
            <div className="vacancy-card-header">
              <h3>📍 Location</h3>
            </div>
            <div className="vacancy-card-body">
              <div className="info-grid">
                <div className="info-item">
                  <strong>City:</strong>
                  <span>{vacancy.location?.city || "Not specified"}</span>
                </div>
                <div className="info-item">
                  <strong>Country:</strong>
                  <span>{vacancy.location?.country || "Not specified"}</span>
                </div>
                <div className="info-item">
                  <strong>Workstation:</strong>
                  <span>{vacancy.location?.workstation || "Not specified"}</span>
                </div>
                <div className="info-item">
                  <strong>Travel Required:</strong>
                  <span>{vacancy.location?.travelRequired || "Not specified"}</span>
                </div>
              </div>
            </div>
          </div>

          {/* Time Section */}
          <div className="vacancy-section-card">
            <div className="vacancy-card-header">
              <h3>⏰ Time Details</h3>
            </div>
            <div className="vacancy-card-body">
              <div className="info-grid">
                <div className="info-item">
                  <strong>Start Date:</strong>
                  <span>
                    {vacancy.time?.startDate
                      ? dateFormatter(vacancy.time.startDate)
                      : "Not specified"}
                  </span>
                </div>
                <div className="info-item">
                  <strong>Time Period:</strong>
                  <span>{vacancy.time?.timePeriod || "Not specified"}</span>
                </div>
                <div className="info-item">
                  <strong>Min. Availability:</strong>
                  <span>{vacancy.time?.minAvailability || "Not specified"}</span>
                </div>
                <div className="info-item">
                  <strong>Project Phase:</strong>
                  <span>{vacancy.time?.projectPhase || "Not specified"}</span>
                </div>
              </div>
            </div>
          </div>

          {/* Payment Section */}
          <div className="vacancy-section-card">
            <div className="vacancy-card-header">
              <h3>💰 Payment & Compensation</h3>
            </div>
            <div className="vacancy-card-body">
              <div className="info-grid">
                <div className="info-item">
                  <strong>Hourly Rate:</strong>
                  <span className="payment-value">
                    {vacancy.payment?.hourlyRate || "Not specified"}
                  </span>
                </div>
                <div className="info-item">
                  <strong>Pay Type:</strong>
                  <span>{vacancy.payment?.payType || "Not specified"}</span>
                </div>
                <div className="info-item">
                  <strong>Flights:</strong>
                  <span>{vacancy.payment?.flights || "Not specified"}</span>
                </div>
                <div className="info-item">
                  <strong>Hotel:</strong>
                  <span>{vacancy.payment?.hotel || "Not specified"}</span>
                </div>
              </div>
            </div>
          </div>

          {/* Contact Section */}
          <div className="vacancy-section-card">
            <div className="vacancy-card-header">
              <h3>👤 Contact Information</h3>
            </div>
            <div className="vacancy-card-body">
              <div className="contact-container">
                <div className="contact-item">
                  <span className="contact-icon">👤</span>
                  <div>
                    <span className="contact-label">Name</span>
                    <div>
                      {isLoggedIn ? (
                        <strong>{vacancy.contact?.name || "Not specified"}</strong>
                      ) : (
                        <span className="hidden-contact" onClick={() => navigate("/login")}>
                          ************ <span className="login-tooltip">Please login to view</span>
                        </span>
                      )}
                    </div>
                  </div>
                </div>
                <hr className="contact-divider" />
                <div className="contact-item">
                  <span className="contact-icon">✉️</span>
                  <div>
                    <span className="contact-label">Email</span>
                    <div>
                      {isLoggedIn ? (
                        <a href={`mailto:${vacancy.contact?.email}`}>
                          {vacancy.contact?.email || "Not specified"}
                        </a>
                      ) : (
                        <span className="hidden-contact" onClick={() => navigate("/login")}>
                          ************ <span className="login-tooltip">Please login to view</span>
                        </span>
                      )}
                    </div>
                  </div>
                </div>
                <hr className="contact-divider" />
                <div className="contact-item">
                  <span className="contact-icon">📞</span>
                  <div>
                    <span className="contact-label">Phone</span>
                    <div>
                      {isLoggedIn ? (
                        <a href={`tel:${vacancy.contact?.phone}`}>
                          {vacancy.contact?.phone || "Not specified"}
                        </a>
                      ) : (
                        <span className="hidden-contact" onClick={() => navigate("/login")}>
                          ************ <span className="login-tooltip">Please login to view</span>
                        </span>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* File Download Section */}
          {vacancy.file && (
            <div className="vacancy-section-card file-download-card">
              <div className="vacancy-card-body">
                <div className="file-download-container">
                  <span className="file-icon">📄</span>
                  <div className="file-info">
                    <strong className="file-name">
                      {vacancy.fileName || "Download File"}
                    </strong>
                    <span className="file-label">
                      Additional vacancy information
                    </span>
                  </div>
                  {isLoggedIn ? (
                    <button
                      onClick={handleDownloadFile}
                      className="download-button"
                    >
                      📥 Download
                    </button>
                  ) : (
                    <button
                      onClick={() => navigate("/login")}
                      className="download-button download-button-login"
                    >
                      🔒 Login to Download
                    </button>
                  )}
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default VacancyIndividual;

